import styled from "styled-components";
import {fontFamilies} from "../../theme/tokens";

/**
 * Externalized styles for the over-cap wall (ui#1454) — the strip the composer renders under the
 * selection when a FREE sender is over the free cap. Token-driven (epic #26), so light and dark fall
 * out for free.
 *
 * Deliberately NOT {@link ./UpgradeHints.styles.NudgeRoot}'s gold treatment, and that is a product
 * decision rather than a palette preference: gold is this app's UPGRADE signal, worn by every "you have
 * hit a paid-plan limit, subscribe" affordance. The strip was built as the opposite offer, a one-off
 * purchase with no subscription attached (sold no more since kitecorp/transferify-ui#3800), and its plan
 * press keeps this treatment.
 */
export const OverLimitRoot = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 9px;
	background: ${({theme}) => theme.tokens.signalTint};
	border: 1px solid ${({theme}) => theme.tokens.signalTint};
	border-radius: 11px;
	padding: 9px 11px;
	margin-top: 10px;
	font-size: 12.5px;
	color: ${({theme}) => theme.tokens.ink2};
	line-height: 1.4;

	> span {
		min-width: 0;
		flex: 1 1 210px;
	}
`;

/**
 * THE single call to action on this surface (owner constraint, ui#1454: one CTA, no subscription pitch
 * competing beside it). There is deliberately no second button, no "compare plans" link and no upgrade
 * pill in this file — `scripts/over-limit-single-cta-sweep.mjs` fails the build if one appears.
 */
export const PayAction = styled.button`
	margin-inline-start: auto;
	flex: none;
	min-height: 40px;
	background: ${({theme}) => theme.tokens.teal};
	color: ${({theme}) => theme.tokens.tealInk};
	border: none;
	font: 700 12px ${fontFamilies.sans};
	padding-inline: 13px;
	border-radius: 9px;
	cursor: pointer;
	transition: filter 160ms ease;

	&:hover {
		filter: brightness(0.92);
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
	}

	@media (max-width: 480px) {
		width: 100%;
		min-height: 44px;
	}
`;
